import { useSelector } from 'react-redux';
import './MainLayout.scss';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { resetSession, selectUserSession } from '../store/features/session/userSession';
import { useAppDispatch } from '../store/hooks';
import AppProduct from '../AppProduct';

const isDevMode = process.env.REACT_APP_DEV_MODE === 'true';

const MenuSection = ({
    userSession,
    onSupportModalClicked,
}: {
    userSession: any;
    onSupportModalClicked?: any;
}) => {
    const dispatch = useAppDispatch();
    const catchEvent = (func: any) => (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        func();
    }
    const handleSignOff = catchEvent(() => {
        dispatch(resetSession());
    });
    return (
        <>
            <DropdownButton
                variant="link"
                title={userSession.username}
            >
                <Dropdown.Item onClick={() => onSupportModalClicked(true)}>Need support ?</Dropdown.Item>
                {/* <Dropdown.Item>Profile</Dropdown.Item> */}
                <Dropdown.Divider />
                <Dropdown.Item onClick={handleSignOff}>Sign off</Dropdown.Item>
            </DropdownButton>
        </>
    )
}

export const MainLayout = ({
    children,
    showTopBar = true,
    onSupportModalClicked,
}: {
    children: any;
    showTopBar?: boolean;
    onSupportModalClicked?: any;
}) => {
    const userSession = useSelector(selectUserSession);
    return (
        <div className="MainLayout d-flex flex-column overflow-auto" id="app-main-layout">
            {showTopBar ? 
                <div className="MainLayoutHeader d-flex p-1" id="app-main-layout-menu">
                    <div className="align-items-center d-none d-sm-flex">
                        {isDevMode ? <span className="badge bg-warning ms-2 rounded d-flex align-items-center h-100"><span className="fw-semibold text-dark">Test Environment</span></span>: null}
                    </div>
                    <div className={'d-none d-sm-flex flex-grow-1 align-items-center ' + (isDevMode ? 'justify-content-center' : 'justify-content-start ps-3')}>
                        <img src="/img/fiducial-securemail-logo.png" alt="" height="100%" />
                        <span className="fs-1 fw-lighter d-none">{AppProduct.companyProductName}</span>
                    </div>
                    <div className="d-flex d-sm-none flex-grow-1 align-items-center justify-content-start">
                        <img src="/img/fiducial-securemail-logo.png" alt="" height="100%" />
                        <span className="fs-1 fw-lighter d-none">{AppProduct.companyProductName}</span>
                    </div>
                    <div className="d-flex justify-content-end align-items-center">
                        {userSession ?
                            <MenuSection
                                userSession={userSession}
                                onSupportModalClicked={onSupportModalClicked}
                            />
                        : null}
                    </div>
                </div> : null
            }
            {children}
        </div>
    );
}

export default MainLayout;